var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex sm12 m12 contratos-base" },
    [
      _c(
        "form-fields-container",
        [
          _c(
            "v-flex",
            { staticClass: "sm12 md12 layout wrap ma-4" },
            [
              _c(
                "v-flex",
                { staticClass: "sm12 md12 layout wrap ma-2" },
                [
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm4 md3 xl2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Ejecutivo",
                          items: _vm.ejecutivos,
                          "item-text": "nombre_completo",
                          "item-value": "email",
                          required: "",
                          "return-object": "",
                          "prepend-icon": "person",
                          clearable: ""
                        },
                        on: { change: _vm.handleChangeEjecutivo },
                        model: {
                          value: _vm.ejecutivo,
                          callback: function($$v) {
                            _vm.ejecutivo = $$v
                          },
                          expression: "ejecutivo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm4 md3 xl2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Rut Cliente",
                          items: _vm.ruts,
                          "item-text": "rut",
                          "item-value": "rut",
                          clearable: "",
                          "prepend-icon": "badge"
                        },
                        model: {
                          value: _vm.filtrosGrilla.rut,
                          callback: function($$v) {
                            _vm.$set(_vm.filtrosGrilla, "rut", $$v)
                          },
                          expression: "filtrosGrilla.rut"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm4 md3 xl2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Razón Social",
                          items: _vm.clientes,
                          "item-text": "cliente",
                          "item-value": "cliente",
                          clearable: "",
                          "prepend-icon": "apartment"
                        },
                        model: {
                          value: _vm.filtrosGrilla.cliente,
                          callback: function($$v) {
                            _vm.$set(_vm.filtrosGrilla, "cliente", $$v)
                          },
                          expression: "filtrosGrilla.cliente"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm4 md3 xl2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Estado de Firma",
                          items: _vm.estadosFirma,
                          "item-text": "estado_firma",
                          "item-value": "id_estado_firma",
                          clearable: "",
                          "prepend-icon": "contact_support"
                        },
                        model: {
                          value: _vm.filtrosGrilla.estadoFirmaId,
                          callback: function($$v) {
                            _vm.$set(_vm.filtrosGrilla, "estadoFirmaId", $$v)
                          },
                          expression: "filtrosGrilla.estadoFirmaId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm4 md3 xl2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Tipo de Fecha",
                          items: _vm.tiposFechas,
                          "item-text": "tipo_fecha",
                          "item-value": "id_tipo",
                          required: "",
                          "prepend-icon": "edit_calendar"
                        },
                        on: { change: _vm.handleTipoFechaNombre },
                        model: {
                          value: _vm.filtrosGrilla.tipoFecha,
                          callback: function($$v) {
                            _vm.$set(_vm.filtrosGrilla, "tipoFecha", $$v)
                          },
                          expression: "filtrosGrilla.tipoFecha"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm4 md3 xl2" },
                    [
                      _c("date-picker", {
                        attrs: {
                          label: _vm.tipoFechaDesdeLabel,
                          isClearable: true,
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtrosGrilla.fechaDesde,
                          callback: function($$v) {
                            _vm.$set(_vm.filtrosGrilla, "fechaDesde", $$v)
                          },
                          expression: "filtrosGrilla.fechaDesde"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm4 md3 xl2" },
                    [
                      _c("date-picker", {
                        attrs: {
                          label: _vm.tipoFechaHastaLabel,
                          isClearable: true,
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtrosGrilla.fechaHasta,
                          callback: function($$v) {
                            _vm.$set(_vm.filtrosGrilla, "fechaHasta", $$v)
                          },
                          expression: "filtrosGrilla.fechaHasta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticClass:
                        "xs12 sm4 md3 xl2 layout wrap mt-0 justify-center"
                    },
                    [
                      _c(
                        "v-btn",
                        { on: { click: _vm.handleActivarBuscadorAutomatico } },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("search")
                          ]),
                          _vm._v("Filtrar\n          ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.recargarGrilla({
                                limpiarFiltros: true
                              })
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("clear")
                          ]),
                          _vm._v("Limpiar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-flex",
                { staticClass: "sm12 md12 layout justify-between wrap ma-2" },
                [
                  _c(
                    "v-flex",
                    { staticClass: "xs12 sm6 px-0" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "xs12 sm12 lg8 px-0" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Buscar...",
                              clearable: "",
                              "prepend-icon": "search"
                            },
                            on: { input: _vm.handleInputFiltros },
                            model: {
                              value: _vm.filtrosGrilla.busquedaRapida,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.filtrosGrilla,
                                  "busquedaRapida",
                                  $$v
                                )
                              },
                              expression: "filtrosGrilla.busquedaRapida"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticClass:
                        "xs12 sm6 layout justify-end align-center wrap ma-0"
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.obtenerExcel }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("\n              \n            "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar"),
                            _c("br"),
                            _vm._v("Excel")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0",
                          attrs: { color: "#F7E100" },
                          on: { click: _vm.crearNuevoContrato }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v("add_circle_outline")
                          ]),
                          _vm._v("\n            Nuevo Contrato\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { staticClass: "xs12 sm12" },
            [
              _c("mantenedor-grid-sin-codigo", {
                attrs: {
                  gridOptions: _vm.gridOptions,
                  funcionalidadId: _vm.funcionalidad
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.abrirModalAgregar
        ? _c("contrato-modal-agregar", {
            on: { cerrar: _vm.handleCerrarModales }
          })
        : _vm._e(),
      _vm.abrirModalEditar
        ? _c("contrato-modal-editar", {
            attrs: {
              contratoId: _vm.contratoId,
              esModoVerDetalle: _vm.esModalVerDetalle
            },
            on: { cerrar: _vm.handleCerrarModales }
          })
        : _vm._e(),
      _vm.abrirModalReportes
        ? _c("modal-confirmacion-reporte-creado", {
            attrs: { texto: _vm.textoReportes },
            on: { cerrar: _vm.handleCerrarModales }
          })
        : _vm._e(),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.mostrarModalConfirmacion,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: "¿Está seguro que desea eliminar el contrato?",
          textoBtnSi: "Eliminar",
          textoBtnNo: "Cancelar"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.mostrarConfirmacion($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }